// extracted by mini-css-extract-plugin
export default {"container":"OTPInput_container__N4gw2","input-flash":"OTPInput_input-flash__64BDJ"};